<template>
  <div id="app">
    <alert-bar/>
    <modal v-if="modal.show" :modal="modal"/>
    <router-view/>
  </div>
</template>

<script>
// import 'velocity-animate'
import { actions, getters } from './views/utils'

export default {
  computed: getters('modal'),
  methods: actions(
    'CHECK_SCREEN_SIZE',
    'CHECK_LOGIN',
    'SYNC_GLOBAL',
    'INIT_STORE',
  ),
  watch: {
    isAuth: {
      immediate: true,
      handler(isAuth) {
        if (isAuth) this.SYNC_GLOBAL()
      },
    },
  },
  created() {
    this.INIT_STORE(this)
    this.CHECK_SCREEN_SIZE()
    this.LOAD(this.CHECK_LOGIN)

    this.ON({
      resize: this.CHECK_SCREEN_SIZE,
    })
  },
  beforeDestroy() {
    this.OFF({
      resize: this.CHECK_SCREEN_SIZE,
    })
  },
}
</script>

<style lang="scss">
@import './views/style/global';
@import './views/style/variables';
@import './views/style/animations';

html, body, #app, #view {
  height: 100%;
  width: 100%;
}

html {
  overflow-x: hidden;
}

body {
  background-color: $bg-body;
  color: $c-text;
  font-family: $font-body;
  font-size: $f-size;
  margin: 0;
}

#app {
  font-family: $font-body;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

#view {
  padding-top: 2rem;
}

a {
  color: $c-link;
  text-decoration: none;
  &:focus {
    color: $c-link-active;
    border-color: $c-link-active;
    outline: none;
  }
  &:hover {
    color: $c-link-hover;
    border-color: $c-link-hover;
  }
}

input, select, textarea {
  border: 1px solid $c-gray;
  border-radius: $r;
  padding: 0.25rem 0.5rem;
}

h1 {
  font-size: $h1;
}

h2 {
  font-size: $h2;
}

h3 {
  font-size: $h3;
}

.splash {
  align-items: center;
  display: flex;
  height: 100%;
  position: absolute;
  width: 100%;
  > .loader {
    font-size: $h7 / 1.5;
  }
  &.rel {
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue